import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-4">Indoctri-NATION 365</h3>
            <p className="text-gray-300 mb-4">
              A Practical Guide for "White" People Ready to Help Dismantle Systemic Racism
            </p>
            <p className="text-gray-400 text-sm">
              Educational resources for understanding and addressing systemic racism through 
              truth, accountability, and meaningful action.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About the Author
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-gray-300 hover:text-white transition-colors">
                  Get the Book
                </Link>
              </li>
              <li>
                <Link to="/learn" className="text-gray-300 hover:text-white transition-colors">
                  Interactive Learning
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Speaking Requests
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://linkedin.com/in/synergyunlimited" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 Synergy Unlimited LLC. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-1">
            INDOCTRI-NATION 365 is published by Buckingham Publishing. Rights owned by Synergy Unlimited LLC.
          </p>
        </div>
      </div>
    </footer>
  )
}